import React, {useEffect, useState} from "react";

const Title = props => {
    const { page, mobile } = props;
    const [ title, setTitle ] = useState(null);

    const initTitle = () => {
        switch (page) {
            case "dashboard":
                setTitle("Tableau de bord");
                break;
            case "client":
				if (mobile) setTitle("Clients");
				else setTitle(null);

                break;
            case "developmentRequest":
				if (mobile) setTitle("Demandes d'évolution");
				else setTitle(null);

                break;
            default:
				setTitle(null);
				break;
        }
    }

    useEffect(() => {
        initTitle();
    }, [page, mobile]);

    return (title !== null && <p className={"title"}>{ title }</p>);
}

export default Title;
